import buildQuery from './buildQuery'

export default buildQuery
